import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ReviewRedirect = () => {
  const { platform } = useParams();
  const [businessInfo, setBusinessInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchBusinessInfoAndRedirect = async () => {
      try {
        // Fetch business info to get actual review URLs
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || (window.location.origin.includes('localhost') ? 'http://localhost:8000' : window.location.origin + '/pandvah-backend')}/api/business-info`);
        
        if (response.ok) {
          const data = await response.json();
          setBusinessInfo(data.business_info);
          
          // Define the mapping between platform names and business info fields
          const platformMapping = {
            google: data.business_info?.google_reviews_link,
            yelp: data.business_info?.yelp_reviews_link,
            facebook: data.business_info?.facebook_reviews_link
          };

          const targetUrl = platformMapping[platform?.toLowerCase()];
          
          if (targetUrl && targetUrl.trim()) {
            // Redirect to the actual review platform URL
            window.location.href = targetUrl;
          } else {
            // Fallback to review page if platform not configured
            setError(true);
          }
        } else {
          setError(true);
        }
      } catch (error) {
        console.error('Error fetching business info for redirect:', error);
        setError(true);
      }
    };

    if (platform) {
      fetchBusinessInfoAndRedirect();
    } else {
      setError(true);
    }
  }, [platform]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Review Link Not Available</h1>
          <p className="text-gray-600 mb-4">The review platform you're looking for is not currently configured.</p>
          <a 
            href="/review-us" 
            className="inline-block bg-theme-blue text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Reviews Page
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-theme-blue mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to {platform} reviews...</p>
      </div>
    </div>
  );
};

export default ReviewRedirect;